import React from 'react';
import { pick } from 'ramda';

import { componentService } from '@core/js/services/component.service';
import { useAppSelector } from '@core/js/store/hooks';

import { clsx } from '@interlayer/js/utils/classNames.util';

import { ICON_ROOT_FOLDER } from './constants';
import { TSvgIconProps } from './types';

import style from './SvgIcon.scss';

const checkUrl = (url?: string) => {
    if (!url || !url?.includes(ICON_ROOT_FOLDER)) {
        return;
    }

    return `${url}#${url?.replace(ICON_ROOT_FOLDER, '')
        .replaceAll('/', '-')
        .replace('.svg', '')
    }`;
};

export const SvgIcon: React.FC<TSvgIconProps> = ({
    type,
    url,
    height,
    width,
    className,
    color = '',
    onClick,
    style: styleProp = {},
    ...other
}) => {
    const { themeName } = useAppSelector(pick(['themeName']));

    const checkColor = () => {
        if (!color) {
            return '';
        }

        return color.startsWith('#') ? color : `var(--${color})`;
    };

    const iconNameWithHash = `${type}.svg#${type}`;

    const xlinkHref = checkUrl(url)
        || (
            type.startsWith('lib-')
                ? `/library/svgIcons/${iconNameWithHash}`
                : `/${themeName}/js/app-out/img/styles__assets__icons__${iconNameWithHash}`
        );

    return (
        <svg
            data-testid={`SvgIcon_icon ${type}`}
            className={clsx(style.icon, className)}
            color={checkColor()}
            fill="currentColor"
            style={{ ...styleProp, width, height }}
            {...onClick && { onClick }}
            {...other}
        >
            <use height="100%" width="100%" xlinkHref={xlinkHref} />
        </svg>
    );
};

componentService.registerWebContentComponents({ SvgIcon });
